export default __webpack_public_path__ + "static/tag-do-1-dark-5fd2f7bb8dab42f8805eac95e223bc173ff0a53b9208cbeb64054903a3909927.png";